import React from "react";
import { Link } from "react-router-dom";
import appRoutes from "../../../routes/app.routes";
import HvButton from "./HvButton";
import Reveal from "./Reveal";

const FinalCTA = () => {
  return (
    <section className="hv2-final-cta" id="final-cta">
      <div className="home-v2__container">
        <Reveal as="h2" className="home-v2__h1 hv2-final-cta__headline">
          Your next opportunity
          <br />
          <span className="home-v2__highlight">could start here</span>
        </Reveal>
        <Reveal as="p" delay={0.08} className="home-v2__body-lg hv2-final-cta__sub">
          Join thousands of professionals and employers already on employHER.
        </Reveal>
        <Reveal delay={0.16} className="hv2-final-cta__btn-group">
          <HvButton variant="primary" size="lg" to={appRoutes.userSignUp.path}>
            Join employHER →
          </HvButton>
          <Link to={appRoutes.userLogin.path} className="hv2-btn-text">
            Already a member? Log in
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
